<template>
  <div class="proposal-data">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>数据维护</el-breadcrumb-item>
      <el-breadcrumb-item>提案数据维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form" method="post" enctype ="multipart/form-data">
        <el-form-item  label="提案类别">
          <el-select  size="mini" v-model="searchParams.currentpType" style="width:120px;" filterable placeholder="Core/Guest/ToO/Temp" clearable>
                  <el-option
                      v-for="item in proposaltype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="观测ID">
          <el-autocomplete
            class="inline-input"
            v-model="searchParams.obs_id"
            :fetch-suggestions="querySearch"
            :placeholder="`${$t('proposal.obs_id')}`"
            :trigger-on-focus="false"
            @select="handleSelect"
            clearable
          ></el-autocomplete>
          <!-- <el-input size="mini"  v-model="searchParams.obs_id"></el-input> -->
        </el-form-item>
        <el-form-item label="公开">
          <el-select size='mini' v-model="searchParams.isopenum" style="width:100px;" filterable :placeholder="$t('proposal.isopen')" clearable>
                  <el-option
                      v-for="item in Iopen"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="">
          <el-select size='mini' v-model="searchParams.currentStatus" style="width:120px;" filterable :placeholder="$t('proposal.status')" clearable>
                  <el-option
                      v-for="item in datastatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="propinsert">新增</el-button>
        </el-form-item>

        <!-- <el-form-item>
          <el-button size="small"  @click="excelinsert">CSV格式导入</el-button>
        </el-form-item> -->

        <el-form-item>
          <el-button size="mini"  @click="excelinsert">CSV文件数据批量导入</el-button>
          <input
            class="upload-input"
            ref="file-input"
            type="file"
            name="source"
            @change="handleFileChange"
            accept=".csv">
        </el-form-item>

        <el-form-item>
          <el-button size="mini"  @click="txtinsert">提案公开状态批量修改(Txt文件上传)</el-button>
          <input
            class="uptxtload-input"
            ref="file-input"
            type="file"
            name="source"
            @change="handleTxtFileChange"
            accept=".txt">
        </el-form-item>
      </el-form>

      

      <!-- <div>
        <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
        </el-button>
        <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
        </el-button>
      </div> -->
      <el-table
        :data="list"
        style="width: 100%;"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          fixed
          prop="obs_id"
          label="观测号">        
        </el-table-column>
        <el-table-column
          prop="schedule_id"
          label="计划号">
        </el-table-column>   
        <el-table-column
          prop="tstart"
          label="数据开始时间TT">
        </el-table-column>
        <el-table-column
          prop="tsop"
          label="数据结束时间TT">
        </el-table-column>
        <el-table-column
          prop="start_utc"
          label="数据开始时间UTC">
        </el-table-column>
        <el-table-column
          prop="stop_utc"
          label="数据结束时间UTC">
        </el-table-column>
        <el-table-column
          prop="duration"
          label="数据时长">
        </el-table-column>
        <el-table-column
          prop="pre_slew"
          label="Pre-Slew"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="post_slew"
          label="post_slew"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="target"
          label="目标">
        </el-table-column>
        <el-table-column
          prop="obs_mode"
          label="观测模式">
        </el-table-column>
        <el-table-column
          prop="data_mode"
          label="数据模式">
        </el-table-column>
        <el-table-column
          prop="proposal"
          label="观测提案">
        </el-table-column>
        <el-table-column
          prop="observer"
          label="观测者">
        </el-table-column>
        <el-table-column
          prop="ptype"
          label="提案类型">
        </el-table-column>
        <el-table-column
          prop="status"
          label="数据状态">
        </el-table-column>
        <el-table-column
          prop="ra"
          label="Ra">
        </el-table-column>
        <el-table-column
          prop="dec"
          label="Dec">
        </el-table-column>
        <el-table-column
          prop="speed"
          label="扫描速度">
        </el-table-column>
        <el-table-column
          prop="interval"
          label="扫描间隔">
        </el-table-column>
        <el-table-column
          prop="radius"
          label="扫描半径">
        </el-table-column>
        <el-table-column
          prop="offset"
          label="偏轴标记">
        </el-table-column>
        <el-table-column
          prop="owner"
          label="权属">
        </el-table-column>
        <el-table-column
          prop="isopen"
          label="公开">
        </el-table-column>
        <el-table-column
          prop="archive_time"
          label="数据归档日期">
        </el-table-column>
        <el-table-column
          prop="release_time"
          label="发布时间">
        </el-table-column>
        <el-table-column
          prop="open_time"
          label="数据公开日期">
        </el-table-column>
        <el-table-column
          prop="l1_file_id"
          label="l1_file_id">
        </el-table-column>
        <el-table-column
          prop="l15_file_id"
          label="l15_file_id">
        </el-table-column>
        <el-table-column
          prop="l2_file_id"
          label="l2_file_id">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="生成时间">
        </el-table-column>
        <el-table-column
          prop="create_by"
          label="生成者">
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="更新时间">
        </el-table-column>
        <el-table-column
          prop="update_by"
          label="更新者">
        </el-table-column>
        <el-table-column
          fixed="right"
          width="100">
          <template slot="header" slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="BatchEdit">
              批量修改
            </el-button>
          </template>
          <template slot-scope="scope">
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="propEdit(scope.row)">
              编辑
            </el-button>
            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.id"
              type="text"
              size="small"
              @click="propDelete(scope.row.id)">
              删除
            </el-button>                   
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
      
      <PropEditDialog
        :dialog-visible="PropEditIsVisible"
        :dialog-data="currentEditData"
        @ok="confirmPropEditDialog"
        @close="closePropEditDialog">
      </PropEditDialog>

      <PropInsertDialog
        :dialog-visible="PropInsertIsVisible"
        :dialog-data="currentInsertData"
        @ok="confirmPropInsertDialog"
        @close="closePropInsertDialog">
      </PropInsertDialog>

      <PropExcelInsertDialog
        :dialog-visible="PropExcelInsertIsVisible"
        :dialog-data="currentExcelInsertData"
        @ok="confirmPropExcelInsertDialog"
        @close="closePropExcelInsertDialog">
      </PropExcelInsertDialog>

      <PropBatchEditDialog
        :dialog-visible="PropBatchEditIsVisible"
        :dialog-data="currentBatchEditData"
        @ok="confirmBatchEditDialog"
        @close="closeBatchEditDialog">
      </PropBatchEditDialog>
    </div>

  </div>
</template>

<script>
import {proposaltype,datastatus,Iopen} from '../common';
import PropEditDialog from './PropEditDialog.vue';
import PropInsertDialog from './PropInsertDialog.vue';
import PropExcelInsertDialog from './PropExcelInsertDialog.vue';
import PropBatchEditDialog from './PropBatchEditDialog.vue';
import axios from 'axios';

export default {
  name: 'ProposalData',
  components: {
    PropEditDialog,
    PropInsertDialog,
    PropExcelInsertDialog,
    PropBatchEditDialog,
  },
  data() {
    return {
      searchParams: {
        currentpType:'',
        obs_id:'',
        isopenum:'',
        currentStatus:'',
      },
      list: [],
      restaurants: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      Iopen:Iopen,
      // checkedisstate:false,
      proposaltype: proposaltype,
      datastatus: datastatus,
      applyIsVisible: false,
      applyForm: {
        name: '',
        applyemail: '',
        applycop: '',
      },
      PropExcelInsertIsVisible:false,
      PropEditIsVisible:false,
      PropInsertIsVisible:false,
      PropBatchEditIsVisible:false,
      currentExcelInsertData:null,
      currentInsertData: null,
      currentEditData:null,
      currentBatchEditData:null,
      multipleSelection:[],
    };
  },
  created() {
    this.getData();
    this.getobsiddata();
  },
  methods: {
    getData() {
      //@Todo 诡异的查询  在数据是否公开的条件，选择未公开时，搜出的结果有公开数据
      // console.log('isopenum',this.searchParams.isopenum);
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ptype: this.searchParams.currentpType,
        status: this.searchParams.currentStatus,
        isopenum: this.searchParams.isopenum,
        obs_id: this.searchParams.obs_id,
      }
      axios.post('/iapi/data', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
    },
    getobsiddata(){
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
      axios.post('/iapi/getobslist',params).then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
          // console.log('target-list',this.restaurants );
        }
      });
    },
    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
    },
    handleSelect() {
        // console.log(item);
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
        };
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    propinsert(){
      this.PropInsertIsVisible = true ;
      this.currentInsertData = null;
    },
    closePropInsertDialog(){
      this.PropInsertIsVisible = false;
    },
    confirmPropInsertDialog(data){
      this.closePropInsertDialog();
      const params = {
        obs_id : data.obs_id,
        schedule_id : data.schedule_id,
        tstart : data.tstart,
        tsop : data.tsop,
        start_utc : data.start_utc,
        stop_utc : data.stop_utc,
        duration : data.duration,
        pre_slew : data.pre_slew,
        post_slew : data.post_slew,
        target : data.target,
        obs_mode : data.obs_mode,
        data_mode : data.data_mode,
        proposal : data.proposal,
        observer : data.observer,
        ptype : data.ptype,
        status : data.status,
        ra : data.ra,
        dec : data.dec,
        speed : data.speed,
        interval : data.interval,
        radius : data.radius,
        offset : data.offset,
        owner : data.owner,
        isopen : data.isopen,
        archive_time : data.archive_time,
        release_time : data.release_time,
        open_time : data.open_time,
        l1_file_id : data.l1_file_id,
        l15_file_id : data.l15_file_id,
        l2_file_id : data.l2_file_id,
        create_time : data.create_time,
        create_by : data.create_by,
        update_time : data.update_time,
        update_by : data.update_by,
      }
      axios.post('/iapi/Propinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增proposal数据成功！');
        }
      });
      this.getData();  
    },
    propEdit(dataId){
      this.PropEditIsVisible = true;
      this.currentEditData = dataId;
    },
    closePropEditDialog(){
      this.PropEditIsVisible = false;
    },
    closePropExcelInsertDialog(){
      this.PropExcelInsertIsVisible = false;
      this.currentExcelInsertData = null;
    },
    confirmPropExcelInsertDialog(data){
      this.closePropExcelInsertDialog();
      const params = {
        data: data,
      };
      axios.post('/iapi/insertPropExcel', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('CSV数据导入成功！');
        }
      });
      this.getData();
      // console.log('data',data);
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
      // console.log('多选内容',this.multipleSelection);
    },
    confirmPropEditDialog(data){
      this.closePropEditDialog();
      const params = {
        id : data.id,
        obs_id : data.obs_id,
        schedule_id : data.schedule_id,
        tstart : data.tstart,
        tsop : data.tsop,
        start_utc : data.start_utc,
        stop_utc : data.stop_utc,
        duration : data.duration,
        pre_slew : data.pre_slew,
        post_slew : data.post_slew,
        target : data.target,
        obs_mode : data.obs_mode,
        data_mode : data.data_mode,
        proposal : data.proposal,
        observer : data.observer,
        ptype : data.ptype,
        status : data.status,
        ra : data.ra,
        dec : data.dec,
        speed : data.speed,
        interval : data.interval,
        radius : data.radius,
        offset : data.offset,
        owner : data.owner,
        isopen : data.isopen,
        archive_time : data.archive_time,
        release_time : data.release_time,
        open_time : data.open_time,
        l1_file_id : data.l1_file_id,
        l15_file_id : data.l15_file_id,
        l2_file_id : data.l2_file_id,
        create_time : data.create_time,
        create_by : data.create_by,
        update_time : data.update_time,
        update_by : data.update_by,      
      }
      axios.post('/iapi/Propedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑proposal数据成功！');
        }
      });
      this.getData();  
    },
    propDelete(DataID){
      const params = {
        data_id: DataID,
      };
      axios.post('/iapi/Propdelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除proposal数据成功！');
        }
      });
      this.getData();
    },

    excelinsert(){
      let inputDOM = document.querySelector('.upload-input');
      inputDOM.click();
    },

    txtinsert(){
      let inputDOM = document.querySelector('.uptxtload-input');
      inputDOM.click();
    },

    handleFileChange() {
      let inputDOM = this.$refs['file-input'];
      if (inputDOM.files.length) {
        let file = inputDOM.files[0];
        let formData=new FormData();
        formData.append('source', file);
        axios({
          url: '/iapi/PropExcel',
          data: formData,
          method: 'post',
          headers:{
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => {
          if (res.data.errcode === 0) {
            this.currentExcelInsertData = res.data.data;
            this.PropExcelInsertIsVisible = true;
          } else {
            this.$message.error('上传文件失败1');
          }
          inputDOM.value = '';
        }).catch((err) => {
          // console.log('err', err);
          this.$message.error('上传文件失败2',err);
        });
      }
    },

    handleTxtFileChange() {
      let inputDOM = this.$refs['file-input'];
      if (inputDOM.files.length) {
        let file = inputDOM.files[0];
        let formData=new FormData();
        formData.append('txt_file', file);
        axios({
          url: '/iapi/PropTxt',
          data: formData,
          method: 'post',
          headers:{
            'Content-Type': 'multipart/form-data',
          },
        }).then((res) => {
          if (res.data.errcode === 0) {
            this.$message(res.data.errmsg);
          } else {
            this.$message.error('上传文件失败1');
          }
          inputDOM.value = '';
        }).catch((err) => {
          // console.log('err', err);
          this.$message.error('上传文件失败2',err);
        });
      }
    },

    BatchEdit(){
      if(this.multipleSelection.length===0){
        alert('请选择数据!')
        return;
      }
      this.PropBatchEditIsVisible = true;
      this.currentBatchEditData = this.multipleSelection;
    },
    closeBatchEditDialog(){
      this.PropBatchEditIsVisible = false;
      this.currentBatchEditData = [];
    },
    confirmBatchEditDialog(data){
      this.closeBatchEditDialog();
      const params = {
        isopenum:data.isopenum,
        currentStatus:data.currentStatus,
        data:this.multipleSelection,
      };
      axios.post('/iapi/BatchUpdate', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('批量修改数据成功！');
        }
      });
      this.getData();
      // console.log('this.multipleSelection',this.multipleSelection);
    },
  },
};
</script>

<style scoped>
.proposal-data {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
.upload-input {
  display: none;
}
.uptxtload-input {
  display: none;
}
</style>